import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { PROJECT_STATUS_COLORS } from '@witmetrics/unison-core';
import { classes, styles } from './utils';

export type ProjectStatusCircleProps = {
  className?: string;
  style?: CSSProperties;
  size?: number;
  projectStatusId: keyof typeof PROJECT_STATUS_COLORS;
};

export default function ProjectStatusCircle({
  className,
  style = {},
  size = 16,
  projectStatusId,
}: ProjectStatusCircleProps) {
  return (
    <div
      style={{ ...styles.wrapper(size), ...style }}
      className={twMerge(
        classes.wrapper,
        PROJECT_STATUS_COLORS[projectStatusId].bg,
        className
      )}
    />
  );
}
